/**
 * Storage Credentials API Client
 *
 * Frontend wrapper for storage credentials CRUD operations
 */

import axios from '@/axios'

export default {
  /**
   * Get all storage credentials for current organization
   */
  async getAll() {
    try {
      const response = await axios.get('/api/storage-credentials')
      return response.data
    } catch (error) {
      console.error('Get storage credentials error:', error)
      throw error
    }
  },

  /**
   * Get single storage credential by ID
   */
  async getById(id) {
    try {
      const response = await axios.get(`/api/storage-credentials/${id}`)
      return response.data
    } catch (error) {
      console.error('Get storage credential error:', error)
      throw error
    }
  },

  /**
   * Create new storage credential
   */
  async create(data) {
    try {
      const response = await axios.post('/api/storage-credentials', data)
      return response.data
    } catch (error) {
      console.error('Create storage credential error:', error)
      throw error
    }
  },

  /**
   * Update existing storage credential
   */
  async update(id, data) {
    try {
      const response = await axios.put(`/api/storage-credentials/${id}`, data)
      return response.data
    } catch (error) {
      console.error('Update storage credential error:', error)
      throw error
    }
  },

  /**
   * Delete storage credential (soft delete)
   */
  async delete(id) {
    try {
      const response = await axios.delete(`/api/storage-credentials/${id}`)
      return response.data
    } catch (error) {
      console.error('Delete storage credential error:', error)
      throw error
    }
  },

  /**
   * Test storage connection
   * @param {Object} data - Either { id } for existing credential or full credential object
   */
  async testConnection(data) {
    try {
      const response = await axios.post('/api/storage-credentials/test', data)
      return response.data
    } catch (error) {
      console.error('Test connection error:', error)
      throw error
    }
  },

  /**
   * Toggle active status of a storage credential
   */
  async toggleActive(id) {
    try {
      const response = await axios.patch(`/api/storage-credentials/${id}/toggle-active`)
      return response.data
    } catch (error) {
      console.error('Toggle active error:', error)
      throw error
    }
  }
}
